module.exports = {
      id: "close-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#close-icon",
      toString: function () {
        return this.url;
      }
    }